import styled from "styled-components";

export const StyleWrap = styled.div`
  .loading-content {
    margin: 0 50%;
    margin-top: 20em;
  }
`;
